import { useCallback } from 'react';
import {
  getOpenPreviewResultsIteration,
  usePreviewResultsIterator,
} from '@mentimeter/slides-preview-results';
import type { TextResponse } from '@core-api/presentation/types/response';

interface UseOpenPreviewResultsProps {
  isEnabled: boolean;
}

export const useOpenPreviewResults = ({
  isEnabled,
}: UseOpenPreviewResultsProps): TextResponse[] => {
  const getNextResults = useCallback(
    (iteration: number, previous: TextResponse[] = []) =>
      getOpenPreviewResultsIteration({
        iteration,
        previous,
      }),
    [],
  );

  return usePreviewResultsIterator(isEnabled, getNextResults) ?? [];
};
